import React from 'react';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import { CommonButton } from '../../../../Styles/CommonStyles';
import { useUpdateassetReqMutation } from '../../../../features/assetrequest/assetReqApiSlice';
import nameStringFn from '../../../../data/nameStringFn';
import { useUpdateMultipleDocsMutation } from '../../../../features/addassets/addassetfinalApiSlice';

// Styled Components
const Button = styled(CommonButton)`
  padding: 8px 16px;
  min-width: 120px;
  margin-right: 10px;
`;

const ForwardButton = styled(Button)`
  background-color: #2196f3;
`;

const ReturnToBOButton = styled(Button)`
  background-color: #ff9800;
`;

const RemarkContainer = styled.div`
  margin-top: 15px;
  width: 100%;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-self: flex-start;
`;

const UnitHeadReturnInboxForm = ({ 
  row, 
  remark, 
  setRemark,
  auth,
  user_current_office,
  getSingleuser,
  handleBack,
  BO_id,
  StoreL1_id
}) => {
  const [updateReq, { isLoading: updateLoading }] = useUpdateassetReqMutation();
  const [updateMultipleAssetDocs] = useUpdateMultipleDocsMutation();

  // Handler for Unit Head to return request to BO
  const handleReturnToBO = async () => {
    if (!remark.trim()) {
      alert("Please provide a remark before returning to BO");
      return;
    }

    // Create senttoData for returning to BO
    let senttoData = {
      sent_to_tag: "unithead_return_to_bo",
      Text: remark,
      action: "Office Asset Return Request Returned to BO by Unit Head",
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: BO_id, name: getSingleuser?.[BO_id]?.name, office: user_current_office, designation: getSingleuser?.[BO_id]?.designation?.[user_current_office] },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[BO_id])}-${user_current_office}-${getSingleuser?.[BO_id]?.designation?.[user_current_office] || 'Unknown'}`,
      time_stamp: new Date()
    };
    
    const body = { id: row?._id, senttoData: senttoData };
    
    try {
      await updateReq(body);
      alert("Return request has been sent back to BO for review.");
      handleBack();
    } catch (error) {
      console.error("Error returning request to BO:", error);
      alert("Error returning request to BO. Please try again.");
    }
  };

  // Handler for Unit Head to forward request to Store
  const handleForwardToStore = async () => {
    if (!remark.trim()) {
      alert("Please provide a remark before forwarding to store");
      return;
    }

    // Create senttoData for forwarding to store
    let senttoData = {
      sent_to_tag: "unithead_forwarded_to_store",
      Text: remark,
      action: "Office Asset Return Request Forwarded to Store by Unit Head",
      sent_by: { id: auth?.id, name: getSingleuser?.[auth?.id]?.name, office: user_current_office, designation: auth?.designation?.[user_current_office] },
      sent_to: { id: StoreL1_id, name: getSingleuser?.[StoreL1_id]?.name, office: row?.req_store, designation: getSingleuser?.[StoreL1_id]?.designation?.[row?.req_store] },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[StoreL1_id])}-${row?.req_store}-${getSingleuser?.[StoreL1_id]?.designation?.[row?.req_store] || 'Unknown'}`,
      time_stamp: new Date(),
    };

    // Update the request to indicate it's now with the store
    const body = { id: row?._id, senttoData: senttoData };
    
    try {
      await updateReq(body);
      alert("Return request has been forwarded to store.");
      handleBack();
    } catch (error) {
      console.error("Error forwarding request to store:", error);
      alert("Error forwarding request to store. Please try again.");
    }
  };

  return (
    <>
      <RemarkContainer>
        <TextField
          label="Remarks"
          multiline
          rows={4}
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          fullWidth
        />
      </RemarkContainer>

      <ButtonsWrapper>
        <ForwardButton onClick={handleForwardToStore}>
          Forward to Store
        </ForwardButton>
        <ReturnToBOButton onClick={handleReturnToBO}>
          Return to BO
        </ReturnToBOButton>
      </ButtonsWrapper>
    </>
  );
};

export default UnitHeadReturnInboxForm; 